import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setEmployeeIDError, setEmployeeInfo } from 'Store/OrderManagement/EmployeeInfo/EmployeeInfoAction';
import { GET_EMPLOYEE_INFO } from 'Store/OrderManagement/EmployeeInfo/EmployeeInfoType';
import UserManagementApiService from 'client/utils/clientApiHelper'
import { CONSTANTS } from 'client/utils/constants';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getEmployeeInfo(empId : any): any {
    try {
        yield put(globalLoaderText("Fetching Employee Info...."));
        const empID = empId.employeeInfo.id
        let payloadData : IPayload = {
        apiType : apiType.Identity,
        endpoint : `userprofile/bvuser/${empID}`,
        apiMethod : apiMethod.GET,
        payload : null
        }
        const response = yield call(
            UserManagementApiService.callUserPost,API_URL.PostWebApp,payloadData
            
        );
        if(response){
        yield put(setEmployeeInfo(response))
        yield put(globalLoaderText(""));   
        yield put(setEmployeeIDError(""))
    }

    } catch (error) {
        yield put(setEmployeeInfo([]))
        yield put(globalLoaderText(""));
        yield put(setEmployeeIDError(CONSTANTS.COMMON_ERROR.EMPLOYEE_ID_NOT_VALID))
    }
}

function* watchGetEmployeeInfo() {
    yield takeEvery(GET_EMPLOYEE_INFO, getEmployeeInfo)
}

export default function* combinedSaga() {
    yield all([
        watchGetEmployeeInfo()
    ])
}